<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C1" :fill="fill">
      <path
        id="C3"
        class="st0"
        d="M612,197.6V97.4c0,0-29.1-19.4-91.4,11.3l41.9-6.9v14.7l-79.3,13.1c-6.7,2.7-13.4,3.7-20.3,3.4
	l-209.3,34.6v-14.7l49.6-8.2V132l108.2-17.9c0,0,0,0,0,0l98.3-16.3V79.3L386.1,99.7c-17.7-10.1-37-20.4-58.6-28
	c-70.9,40.5-127.1,110.1-164.3,84.2C50.8,77.7,0,128.3,0,128.3v104l272.1-45v7.4L0,239.8V271l225.9-37.4v18.5L0,289.6V330
	c0,0,31.3-45.4,123-35.1c25.8,2.9,46.7,8.9,65.6,16.3l-48.2,8v12.9l69.9-11.6l101-16.7L435,283.3V310l-182.6,30.2
	c25.6,11.4,54.3,21.5,94,26c34.4,3.9,58.5,0.3,77.3-6l73.2-12.1v-6.5l-49.1,8.1l-29.7,4.9v-2.4v-4l46.1-7.6
	c14.2-7.9,27.1-14,45.1-12c49.1,5.5,50.8,35,102.6,40.8V227.1l-359.3,59.5v-29.5L612,197.6z M127.8,187.7l-59.9,9.9v-4.9l59.9-9.9
	V187.7z M432.1,198.3l168.8-27.9v13.9l-168.8,27.9V198.3z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "SportsCover_c3",
  props: ["fill"],
};
</script>
